import { render } from "./stickynav.html?vue&type=template&id=b3a63286&external"
import script from "./stickynav.js?vue&type=script&lang=js&external"
export * from "./stickynav.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__